import React, {Component} from 'react';
import * as api from '../../api';
import 'semantic-ui-css/semantic.min.css';
import WithoutFilteringDatatable from "../../components/table/without-filtering-data-table";
import EnvironmentCommentaryTableHeader from '../EnvironmentalCommentary/environment-commentary-table-header'
import EnvironmentCommentaryTableRow from '../EnvironmentalCommentary/environment-commentary-table-row'
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import ReactGA from 'react-ga';
export default class EnvironmentCommentaryTab extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            dataProvider: new ApiDataProvider(api.getEnvironmentCommetary, [this.props.customerId,this.props.siteKey])
        };
        
    }

    componentDidMount = () => {
       
        ReactGA.pageview('enviro impact tab');
    };

    render() {
        return (
            
            <WithoutFilteringDatatable dataProvider={this.state.dataProvider}  contextData={{customerId: this.props.customerId}} defaultSort={"id"} headerComponent={EnvironmentCommentaryTableHeader} rowComponent={EnvironmentCommentaryTableRow} name={"EnvironmentalImpactCommentary"} />
        );
    }
}